import React, { useEffect } from 'react'
import "./Recent_Transaction.css"
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { GetRecentTransactions } from '../../../../../../features/webisite/wallet/slice';
import CustomPaginate from '../../../../../../common/custompaginate/CustomPaginate';
import { formatAmount } from '../../../../../../utils/common';

function Recent_Transaction() {


  const navigate = useNavigate();
  const dispatch = useDispatch();


  // const transactions = useSelector((state) => state.wallet.recent_transactions);
  const transactions = useSelector((state) => state.WebMasters.wallet);

  useEffect(() => {
    fetch();
  }, [dispatch]);



  const fetch = async (page = 1) => {
    await dispatch(GetRecentTransactions(
      {
        page: page,
        per_page: transactions?.per_page,
      })
    );
  };

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "2-digit",
    });
  };



  return (
    <div className="transactions-container">
      <h3 className="transactions-title">Recent Transactions</h3>

      {/* <div className="transaction-card">
        <div className="transaction-date">
          <span className="date-day">24 Sept 25</span>
        </div>

        
        <div className="transaction-info">
          <h4>Oshin K.</h4>
          <p>Invoice #1</p>
        </div>

        
        <div className="transaction-status">
          <span className="status paid">Paid</span>
          <h4>₹ 20,866.07</h4>
        </div>
      </div> */}
      {transactions?.recent_transactions?.map((txn) => {
        const userName = `${txn?.User?.f_name || ""} ${txn?.User?.l_name || ""}`.trim();

        return (
          <div className="transaction-card" key={txn.id}>

            {/* Left Date Box */}
            <div className="transaction-date">
              <span className="date-day">
                {formatDate(txn?.Order?.invoice_date || txn?.createdAt)}
              </span>
            </div>

            {/* Middle Info */}
            <div className="transaction-info">
              <h4>{userName || "N/A"}</h4>
              {txn?.Order ? <p>Invoice #{txn?.Order?.invoice_no}</p> : <p>Remark : {txn?.remark || "--"}</p>}

            </div>

            {/* Right Status & Amount */}
            <div className="transaction-status">
              {txn?.Order && (
                <span
                  className={`status ${txn?.Order?.payment_status_id === 1 ? "paid" : "unpaid"
                    }`}
                >
                  {txn?.Order?.Payment_Status?.name}
                </span>
              )}

              <h4>₹ {formatAmount(txn?.amount)}</h4>
            </div>



          </div>
        );
      })}

      <CustomPaginate
        currentPage={transactions?.current_page}
        totalPages={transactions?.total_pages}
        handlePageChange={handlePageChange}
      />
    </div>

  )
}

export default Recent_Transaction